import { useCallback, useRef, useState } from 'react';
import { utils as commonUtils } from '@febos-io/common';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useAuthContext } from '../../providers';
import {
  removeUser,
  setLoading
} from '../../store';
import * as actions from '../../store/actions';

const { Auth, } = commonUtils;

export default function useOnSignInCallback(handleSignIn) {
  const [isNewPasswordRequired, setIsNewPasswordRequired] = useState(false);

  const response = useRef(null);
  const navigate = useNavigate();
  const { changePasswordPathname, } = useAuthContext();
  const dispatch = useDispatch();
  const onSignIn = useCallback(async ({ email, password, }, { setErrors, resetForm, }) => {
    try {
      await dispatch(removeUser());
      dispatch(setLoading(true));
      const loggedUser = await Auth.signIn(email.trim(), password);
      console.log('loggedUser', loggedUser);
      const user = JSON.parse(JSON.stringify(loggedUser));
      dispatch(setLoading(false));
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        response.current = user;
        setIsNewPasswordRequired(true);
        resetForm({ values: { email: email.trim(), password: '', newPassword: '', }, });
      } else {
        handleSignIn(user);
      }
    } catch (error) {
      console.error('Error signing in', error);
      dispatch(setLoading(false));
      switch (error.code) {
        case 'PasswordResetRequiredException': {
          navigate(`${changePasswordPathname}?email=${email.trim()}`);
          break;
        }
        case 'NotAuthorizedException': {
          dispatch(actions.handleSignInError({ data: error, }));
          break;
        }
        default: {
          setErrors({
            email: '#',
            password: '#',
          });
        }
      }
    }
  }, [changePasswordPathname, dispatch, handleSignIn, navigate]);

  return {
    onSignIn,
    response,
    isNewPasswordRequired,
    setIsNewPasswordRequired,
  };
}
